import {
  MAINNET_POOL_ID,
  MAINNET_ROUTES,
  // MAINNET_POOL_CONFIG,
  mainnetTokens,
  MAINNET_CONTRACTS_ADDRESSES,
} from "./mainnetConfig";
import {
  TESTNET_CONTRACTS_ADDRESSES,
  // TESTNET_POOL_CONFIG,
  TESTNET_POOL_ID,
  TESTNET_ROUTES,
  testnetTokens,
} from "./testnetConfig";

export const TOKENS = {
  W: mainnetTokens,
  T: testnetTokens,
};

export type TPoolId = MAINNET_POOL_ID | TESTNET_POOL_ID;

export const POOL_ID = {
  W: MAINNET_POOL_ID,
  T: TESTNET_POOL_ID,
};

export const ROUTES = {
  W: MAINNET_ROUTES,
  T: TESTNET_ROUTES,
};

export const POOL_CONFIG = {
  // W: MAINNET_POOL_CONFIG,
  // T: TESTNET_POOL_CONFIG,
};
export const CONTRACT_ADDRESSES_MAP = {
  W: MAINNET_CONTRACTS_ADDRESSES,
  T: TESTNET_CONTRACTS_ADDRESSES,
};

export type TChainId = "W" | "T";

export const NODE_URL_MAP: Record<TChainId, string> = {
  // W: "https://nodes-puzzle.wavesnodes.com",
  // W: "https://wavesducks.wavesnodes.com",
  W: "https://waves-nodes.pepe.team",
  T: "https://nodes-testnet.wavesnodes.com",
};
export const EXPLORER_URL_MAP: Record<TChainId, string> = {
  W: "https://wavesexplorer.com",
  T: "https://testnet.wavesexplorer.com",
};

export const SLIPPAGE = 0.95; //if puzzle slippage = 0
export const TRADE_FEE = 0.95;

export const CASHBACK_PERCENT = 0.004;

export interface IToken {
  assetId: string;
  name: string;
  symbol: string;
  decimals: number;
  logo: string;
}

export interface IPoolConfig {
  contractAddress: string;
  layer2Address?: string;
  baseTokenId: string;
  name: string;
  defaultAssetId0: string;
  defaultAssetId1: string;
  tokens: Array<IToken & { shareAmount: number } & { claimReward?: string }>;
  logo?: string;
}

export const PINATA_JWT = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI0M2RiZjI2Ny01YWVjLTRiNTktOGRkNy02MDJmMThkMDU0MTEiLCJlbWFpbCI6InZpdGd2ckBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJGUkExIn0seyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJOWUMxIn1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiMGMyOWQ4ZDI3YzE2MTY2NThmMzMiLCJzY29wZWRLZXlTZWNyZXQiOiI0ZDE0ZmNlOThlN2ExZDNmMGI0ZWFhNmFhOGU3Y2Q2MTljYTQzMGIwZTY5NGUwMGUxZmYwNWZkNjFlN2FmMjY3IiwiZXhwIjoxNzkwNzQzODc2fQ.kqGR78aMFLNqSRzebFLY7pDwjc21RMnz2dmxtCZL4TI";
